import React from 'react';

import { IIconProps } from 'ui/CircleIconButton';
import { theme } from '../../../../../tailwind.config';

export const CrmActivityCallItem: React.FC<IIconProps> = React.memo(
  ({ fill = theme.colors['green-prime'], background = theme.colors['white'] }) => (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="1" width="23" height="23" rx="3.5" fill={background}/>
      <rect x="0.5" y="1" width="23" height="23" rx="3.5" stroke="#EAE9E8"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M8.86167 11.7942C9.70167 13.445 11.055 14.7925 12.7058 15.6383L13.9892 14.355C14.1467 14.1975 14.38 14.145 14.5842 14.215C15.2375 14.4308 15.9433 14.5475 16.6667 14.5475C16.9875 14.5475 17.25 14.81 17.25 15.1308V17.1667C17.25 17.4875 16.9875 17.75 16.6667 17.75C11.1892 17.75 6.75 13.3108 6.75 7.83333C6.75 7.5125 7.0125 7.25 7.33333 7.25H9.375C9.69583 7.25 9.95833 7.5125 9.95833 7.83333C9.95833 8.5625 10.075 9.2625 10.2908 9.91583C10.355 10.12 10.3083 10.3475 10.145 10.5108L8.86167 11.7942Z" fill={fill} />
    </svg>
  )
);
